export default __webpack_public_path__ + "static/media/us.ff4b19ab.svg";